import React, { Component } from "react";
import { connect } from "react-redux";
import { generatePDF } from "../../../../actions/pdfActions";
import BasicLayout from "../../../common/BasicLayout";
import PDFObject from "pdfobject";
import _ from "lodash";
import { Form, Input, Button, Steps } from "antd";
import styled from "styled-components";

const FormItem = Form.Item;
const Step = Steps.Step;

const FormInput = styled(FormItem)`
  div input {
    border-radius: 15px;
    background: #dfe6e9;
    border: none;

    ::placeholder {
      color: rgba(0, 0, 0, 0.65);
    }

    @media (min-width: 768px) {
      margin: 25px auto 0 auto;
      width: 75%;
    }

    @media (min-width: 992px) {
      margin: 25px auto 0 auto;
      width: 50%;
    }
  }
`;

const CustomButton = styled(Button)`
  && {
    margin-bottom: 25px;
    color: #fff;
    border: none;
    background-color: ${props => props.bgcolor};
    display: block;
    width: 100%;
    white-space: normal;
    height: 50px;
    border-radius: 15px;

    :hover,
    :active,
    :hover {
      background-color: ${props => props.bgcolor};
    }

    @media (min-width: 768px) {
      margin: 0 auto 25px auto;
      width: 75%;
    }

    @media (min-width: 992px) {
      margin: 0 auto 25px auto;
      width: 50%;
    }
  }
`;

const TransitionDiv = styled.div`
  transition: ${props => (props.first ? "1.3.s all" : "1.5s all")};
`;

const steps = [
  {
    render: () => (
      <div>
        <h3 style={{ textAlign: "center", marginBottom: 25 }}>
          Approval Status
        </h3>
        <Steps current={0}>
          <Step title="Employee" description="Submitted By Employee" />
          <Step title="Manager" description="Awaiting approval by Manager" />
          <Step title="Director" description="Awaiting approval by Director" />
        </Steps>
      </div>
    )
  },
  {
    render: () => (
      <div>
        <h3 style={{ textAlign: "center", marginBottom: 25 }}>
          Approval Status
        </h3>
        <Steps current={1}>
          <Step title="Employee" description="Submitted By Employee" />
          <Step title="Manager" description="Awaiting approval by Manger" />
          <Step title="Director" description="Awaiting approval by Director" />
        </Steps>
      </div>
    )
  },
  {
    render: () => (
      <div>
        <h3 style={{ textAlign: "center", marginBottom: 25 }}>
          Approval Status
        </h3>
        <Steps current={2}>
          <Step title="Employee" description="Submitted By Employee" />
          <Step title="Manager" description="Approved by Manager" />
          <Step title="Director" description="Awaiting approval by Director" />
        </Steps>
      </div>
    )
  },
  {
    render: () => (
      <div>
        <h3 style={{ textAlign: "center", marginBottom: 25 }}>
          Approval Status
        </h3>
        <Steps current={3}>
          <Step title="Employee" description="Submitted By Employee" />
          <Step title="Manager" description="Approved by Manager" />
          <Step title="Director" description="Approved by Director" />
        </Steps>
      </div>
    )
  }
];

const directorSteps = [
  {
    render: () => (
      <div>
        <h3 style={{ textAlign: "center", marginBottom: 25 }}>
          Approval Status
        </h3>
        <Steps current={0}>
          <Step title="Director" description="Submitted By Director" />
          <Step
            title="ELT Member"
            description="Awaiting approval by ELT Member"
          />
        </Steps>
      </div>
    )
  },
  {
    render: () => (
      <div>
        <h3 style={{ textAlign: "center", marginBottom: 25 }}>
          Approval Status
        </h3>
        <Steps current={1}>
          <Step title="Director" description="Submitted By Director" />
          <Step
            title="ELT Member"
            description="Awaiting approval by ELT Member"
          />
        </Steps>
      </div>
    )
  },
  {
    render: () => (
      <div>
        <h3 style={{ textAlign: "center", marginBottom: 25 }}>
          Approval Status
        </h3>
        <Steps current={2}>
          <Step title="Director" description="Submitted By Director" />
          <Step title="ELT Member" description="Approved by ELT Member" />
        </Steps>
      </div>
    )
  }
];

class TrackForm extends Component {
  embedPDF = uri => {
    PDFObject.embed(uri, document.getElementById("preview-pane"));
  };

  render() {
    const WrappedTrackFormSubmission = Form.create()(TrackFormSubmission);
    const { loading, uri, form, done } = this.props.pdf;

    return (
      <BasicLayout>
        <div style={{ textAlign: "center", margin: "25px 0" }}>
          <h1 style={{ marginBottom: 0 }}>Track your form</h1>
          <p>Track the status of your form. Enter your form number below</p>
        </div>
        <WrappedTrackFormSubmission
          loading={loading}
          uri={uri}
          done={done}
          generatePDF={this.props.generatePDF}
        />
        {_.isEmpty(form) ? (
          ""
        ) : (
          <TransitionDiv first={true} style={{ padding: 50 }}>
            {_.isEmpty(form.approvals)
              ? steps[0].render()
              : form.data["Title/Position"] === "Employee"
              ? steps[_.size(form.approvals)].render()
              : directorSteps[_.size(form.approvals)].render()}
          </TransitionDiv>
        )}

        <TransitionDiv
          id="preview-pane"
          style={{ height: done ? "650px" : "0px" }}
        >
          <div
            style={{
              display: loading ? "none" : "block",
              textAlign: "center"
            }}
          >
            {done ? this.embedPDF(uri) : ""}
          </div>
        </TransitionDiv>
      </BasicLayout>
    );
  }
}

class TrackFormSubmission extends Component {
  handleSubmit = e => {
    this.props.form.validateFields((err, values) => {
      e.preventDefault();

      if (!err) {
        this.props.generatePDF(values.formNumber);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form style={{ textAlign: "center" }} onSubmit={this.handleSubmit}>
        <FormInput>
          {getFieldDecorator("formNumber", {
            rules: [
              { required: true, message: "Please input your form number" }
            ]
          })(<Input placeholder="Enter your form number" />)}
        </FormInput>
        <FormItem>
          <CustomButton
            htmlType="submit"
            bgcolor="#00b894"
            size="large"
            type="primary"
            loading={this.props.loading}
          >
            Submit
          </CustomButton>
        </FormItem>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  pdf: state.pdf
});

export default connect(
  mapStateToProps,
  { generatePDF }
)(TrackForm);
